import {
  AI_GET_DATA_BY_OPTION,
  AI_GET_DATA_BY_OPTION_SUCCESS,
  AI_SELECT_SCREEN,
  AI_SET_SWOT_DATA,
  AI_SET_TREND_DATA,
} from "modules/tractionAI/store/tractionAI.actions";

const initState = {
  wsConnection: false,
  activeScreen: null, // 'insight',
  activeSubScreen: null, // 'swot',
  scout: {
    history: [],
    fetching: false,
  },
  insight: {
    swot: {
      fetching: false,
      data: [],
    },
    trend: {
      fetching: false,
      data: [],
    },
    companySnapshot: {
      fetching: false,
      data: [],
    },
  },
  recommend: {
    history: [],
    fetching: false,
  },
  populate: {
    history: [],
    fetching: false,
  },
};

const removeEmptyItems = (items) => Object.keys(items)
  .filter(k => items[k].length)
  .reduce((acc, k) => ({...acc, [k]: items[k]}), {})

const updateSWOTWithData = (screenData, newData) => {
  if (newData.createNewSearchItem) {
    return [
      ...screenData,
      {
        searchByQuery: newData.searchByQuery,
        fetched: newData.fetched,
        data: {},
      }
    ];
  }

  const length = screenData.length;

  return screenData.map((el, index) => {
    if (length === index + 1) {
      return {
        ...el,
        fetched: newData.fetched,
        data: removeEmptyItems(newData.data)
      }
    }

    return el;
  });
};

const updateTrendWithData = (screenData, newData) => {
  if (newData.createNewSearchItem) {
    return [
      ...screenData,
      {
        searchByQuery: newData.searchByQuery,
        fetched: newData.fetched,
        data: '',
      }
    ];
  }

  const length = screenData.length;

  return screenData.map((el, index) => {
    if (length === index + 1) {
      return {
        ...el,
        fetched: newData.fetched,
        data: `${newData.data.Response}`
      }
    }

    return el;
  });
}

const applyNoAnimationBoolean = (state, payload) => {
  if (!payload.applyNoAnimationLogic) {
    return {
      ...state,
      ...payload
    }
  }

  return {
    ...state,
    ...payload,
    insight: {
      ...state.insight,
      swot: {
        fetching: false,
        data: state.insight.swot.data.map(el => ({...el, doNotAnimate: true })),
      },
    }
  }
}

const tractionAiReducer = (state = initState, action) => {
  const { type, payload } = action;

  switch (type) {
    case AI_SET_TREND_DATA: {
      return {
        ...state,
        insight: {
          ...state.insight,
          trend: {
            fetching: payload.fetching,
            data: updateTrendWithData(state.insight.trend.data, payload)
          }
        }
      }
    }

    case AI_SET_SWOT_DATA: {
      return {
        ...state,
        insight: {
          ...state.insight,
          swot: {
            fetching: payload.fetching,
            data: updateSWOTWithData(state.insight.swot.data, payload),
          }
        }
      }
    }

    case AI_SELECT_SCREEN: {
      return {
        ...state,
        ...applyNoAnimationBoolean(state, payload),
      }
    }

    case AI_GET_DATA_BY_OPTION: {
      return {
        ...state,
        [payload.option]: {
          ...state[payload.option],
          fetching: true,
        }
      }
    }

    case AI_GET_DATA_BY_OPTION_SUCCESS: {
      return {
        ...state,
        [payload.option]: {
          ...state[payload.option],
          history: [...state[payload.option].history],
          fetching: false,
        }
      }
    }

    default:
      return state;
  }
};

export default tractionAiReducer;
